import { AnimationProps } from "framer-motion";


export enum PushTypes {
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  ALERT = 'alert',
}

export const ANIMATION_PROPS: AnimationProps = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0, transform: 'translateY(120px)', position: 'absolute' },
  transition: { duration: 0.3 },
};
